import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";
import {
  categorySchema,
  type IActivityCategory,
} from "@medoma/models/activities";
import {
  organizationSchema,
  type IOrganization,
} from "@medoma/models/organizations";
import { patientTypeSchema, type IPatientType } from "@medoma/models/patients";
import type { IDurationOption } from "@/forms/AddActivityForm/activityDurationModels";

export type IPostRegisterTemplate = {
  id: string;
  title: MessageDescriptor;
  category: IActivityCategory;
  patientType: IPatientType;
  durationOption: IDurationOption;
  // KVÅ codes matched against `code` on the invoicing catalogue so the template
  // survives renames and translation drift in the `name` field.
  procedureCodes: string[];
  productCodes: string[];
  organizations: IOrganization[];
};

export const postRegisterTemplateDefinitions: IPostRegisterTemplate[] = [
  {
    id: "trygghetskvitto",
    title: msg`Trygghetskvitto`,
    category: categorySchema.enum.AdminTask,
    patientType: patientTypeSchema.enum.AdvancedHomeCare,
    durationOption: "5",
    procedureCodes: ["UV017"],
    productCodes: [],
    organizations: [
      organizationSchema.enum.slso,
      organizationSchema.enum.capioahc,
      organizationSchema.enum.ssh,
    ],
  },
  {
    id: "administrativ-inskrivning",
    title: msg`Administrativ inskrivning`,
    category: categorySchema.enum.AdminTask,
    patientType: patientTypeSchema.enum.AdvancedHomeCare,
    durationOption: "15",
    procedureCodes: ["XS007", "XV015"],
    productCodes: [],
    organizations: [
      organizationSchema.enum.capioahc,
      organizationSchema.enum.ssh,
    ],
  },
  {
    id: "administrativ-inskrivning-slso",
    title: msg`Administrativ inskrivning`,
    category: categorySchema.enum.AdminTask,
    patientType: patientTypeSchema.enum.AdvancedHomeCare,
    durationOption: "15",
    procedureCodes: ["XV016", "XS008"],
    productCodes: [],
    organizations: [organizationSchema.enum.slso],
  },
];
